// Build a map from globalVehicleTrimId → { model, bodyStyle } using the trims array.
// This allows resolving per-vehicle model/bodyStyle when a single incentive spans multiple vehicles.
const buildTrimIdLookup = (trimEntries) => {
	const lookup = {};
	(trimEntries || []).forEach(
		({ model, bodyStyle, globalVehicleTrimIds }) => {
			(globalVehicleTrimIds || []).forEach((id) => {
				lookup[id] = { model, bodyStyle };
			});
		}
	);
	return lookup;
};

// Given a globalVehicleTrims entry and a trimId lookup, find model/bodyStyle for the vehicle.
const resolveVehicleInfo = (gvTrim, trimIdLookup) => {
	const matchId = (gvTrim.globalVehicleTrimIds || []).find(
		(id) => trimIdLookup[id]
	);
	return matchId ? trimIdLookup[matchId] : {};
};

const groupByVehicle = (incentives) => {
	const byVehicle = {};

	incentives.forEach((incentive) => {
		const gvTrims = incentive.globalVehicleTrims;
		if (!gvTrims || gvTrims.length === 0) return;

		const trimIdLookup = buildTrimIdLookup(incentive.trims);

		gvTrims.forEach((gvTrim) => {
			const gvId = gvTrim.globalVehicleId;
			if (!gvId) return;
			if (!byVehicle[gvId]) {
				// applicableYear may be absent; fall back to year embedded in globalVehicleId (e.g. US2026AUD...)
				const yearFromId = parseInt(gvId.substring(2, 6), 10);
				const year =
					incentive.applicableYear ??
					(yearFromId >= 2000 ? yearFromId : undefined);
				// Resolve model/bodyStyle from the trims array; fall back to top-level i18N fields
				const vehicleInfo = resolveVehicleInfo(gvTrim, trimIdLookup);
				byVehicle[gvId] = {
					globalVehicleId: gvId,
					globalVehicleTrimIds: [],
					year,
					make: incentive.applicableMake,
					model: vehicleInfo.model || incentive.i18NApplicableModel,
					bodyStyle:
						vehicleInfo.bodyStyle ||
						incentive.i18NApplicableBodyStyle,
					offerCount: 0,
					offerTypes: [],
					incentives: []
				};
			}

			const vehicle = byVehicle[gvId];
			vehicle.incentives.push(incentive);
			vehicle.offerCount += 1;

			(gvTrim.globalVehicleTrimIds || []).forEach((trimId) => {
				if (!vehicle.globalVehicleTrimIds.includes(trimId)) {
					vehicle.globalVehicleTrimIds.push(trimId);
				}
			});

			if (!vehicle.offerTypes.includes(incentive.incentiveType)) {
				vehicle.offerTypes.push(incentive.incentiveType);
			}
		});
	});

	return byVehicle;
};

export default groupByVehicle;
